import { AlertTriangle, RefreshCw, ShieldCheck } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";

function fmt(value) {
  if (!value) return "jamais";
  return new Date(value).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
}

export const WebhookHealthBanner = () => {
  const [health, setHealth] = useState(null);
  const [checking, setChecking] = useState(false);

  const load = (refresh = false) => api.get("/automations/health", { params: refresh ? { refresh: 1 } : {} }).then(({ data }) => setHealth(data));

  useEffect(() => {
    load().catch(() => {});
  }, []);

  const check = async () => {
    setChecking(true);
    try {
      await load(true);
      toast.success("Webhooks noCRM vérifiés.");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Vérification impossible.");
    } finally {
      setChecking(false);
    }
  };

  if (!health) return null;
  const repaired = (health.rules || []).filter((rule) => rule.action === "reactive" || rule.action === "recree");
  const hasIssues = (health.issues || []).length > 0;

  return (
    <div className={`health-banner ${hasIssues ? "is-error" : repaired.length ? "is-warning" : "is-ok"}`} data-testid="webhook-health-banner">
      {hasIssues ? <AlertTriangle size={16} /> : <ShieldCheck size={16} />}
      <div className="health-text">
        {hasIssues ? (
          <>
            <strong data-testid="webhook-health-status">Webhooks noCRM en défaut</strong>
            {health.issues.map((issue) => <span key={issue}>{issue}</span>)}
          </>
        ) : repaired.length ? (
          <>
            <strong data-testid="webhook-health-status">Webhooks noCRM réparés automatiquement</strong>
            <span>{repaired.map((rule) => `« ${rule.name} » ${rule.action === "reactive" ? "réactivé" : "recréé"}`).join(" · ")} — vérifié {fmt(health.checked_at)}.</span>
          </>
        ) : (
          <strong data-testid="webhook-health-status">Webhooks noCRM actifs ({(health.rules || []).length} règle(s)) — vérifié {fmt(health.checked_at)}, contrôle automatique toutes les 10 min.</strong>
        )}
      </div>
      <button type="button" className="secondary-button" onClick={check} disabled={checking} data-testid="webhook-health-check-button">
        <RefreshCw size={14} className={checking ? "spinning" : ""} /> {checking ? "Vérification…" : "Vérifier maintenant"}
      </button>
    </div>
  );
};
